import React from 'react';
import { X } from 'lucide-react';
import { PRIVACY_CONTENT, TERMS_CONTENT } from '../data/legalContent';
interface LegalModalProps {
  content: 'privacy' | 'terms';
  onClose: () => void;
}
export function LegalModal({
  content,
  onClose
}: LegalModalProps) {
  return <div className="fixed inset-0 z-[10000] flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm" role="dialog" aria-modal="true" aria-label={content === 'privacy' ? 'Política de Privacidad' : 'Términos de Servicio'} onClick={e => {
    if (e.target === e.currentTarget) onClose();
  }} data-id="element-228">
      <div className="bg-[#0f0f11] border border-gold/30 rounded-xl w-full max-w-2xl max-h-[80vh] flex flex-col shadow-2xl" data-id="element-229">
        <div className="flex items-center justify-between p-6 border-b border-white/10" data-id="element-230">
          <h3 className="text-xl font-serif font-bold text-gold uppercase tracking-wider" data-id="element-231">
            {content === 'privacy' ? 'Política de Privacidad' : 'Términos de Servicio'}
          </h3>
          <button onClick={onClose} aria-label="Cerrar" className="text-white/50 hover:text-white transition-colors p-1" data-id="element-232">
            <X size={24} data-id="element-233" />
          </button>
        </div>

        <div className="p-6 overflow-y-auto text-sm text-white/85 space-y-6 leading-relaxed" data-id="element-234">
          {content === 'privacy' ? PRIVACY_CONTENT : TERMS_CONTENT}
        </div>

        <div className="p-6 border-t border-white/10 text-right" data-id="element-235">
          <button onClick={onClose} className="px-6 py-2 bg-white/10 hover:bg-white/20 rounded text-sm font-bold transition-colors" data-id="element-236">
            Cerrar
          </button>
        </div>
      </div>
    </div>;
}